/* assets/tr-color-guide.js (moved out of sections/truerim-color-guide.liquid 2026-10-22 so the browser caches it across the color pages). */
(function () {
  var root = document.getElementById('trcg');
  if (!root || root.getAttribute('data-trcg-ready')) return;
  root.setAttribute('data-trcg-ready', '1');

  /* Method tabs: the panels' tabs and the full-steps switch (2026-10-09). Without JS each pair of panels stays stacked
     with its own headings. Both switches move together: picking Spray gun in either shows the gun steps in both.
     Tabs carry data-trcg-m="aero|gun"; Aerosol is always first. */
  var sets = [];
  [].forEach.call(root.querySelectorAll('[data-trcg-tablist]'), function (list) {
    var tabs = [].slice.call(list.querySelectorAll('[role="tab"]'));
    var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
    if (!tabs.length || !panels.every(Boolean)) return;
    panels.forEach(function (p) { p.setAttribute('role', 'tabpanel'); p.tabIndex = 0; });
    sets.push({ list: list, tabs: tabs, panels: panels });
  });
  if (sets.length) {
    var method = function (t) { return t.getAttribute('data-trcg-m'); };
    var select = function (m) {
      sets.forEach(function (set) {
        set.tabs.forEach(function (t, j) {
          var on = method(t) === m;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          set.panels[j].hidden = !on;
        });
      });
    };
    var picked = false;
    sets.forEach(function (set) {
      var tabs = set.tabs;
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { picked = true; select(method(t)); });
        t.addEventListener('keydown', function (e) {
          var n = null, last = tabs.length - 1;
          if (e.key === 'ArrowRight') n = i === last ? 0 : i + 1;
          else if (e.key === 'ArrowLeft') n = i === 0 ? last : i - 1;
          else if (e.key === 'Home') n = 0;
          else if (e.key === 'End') n = last;
          if (n !== null) { e.preventDefault(); picked = true; select(method(tabs[n])); tabs[n].focus(); }
        });
      });
      set.list.hidden = false;
    });
    root.classList.add('trcg-tabs-on');
    /* Follow the builder's size (Pint/Quart/Gallon = gun) until the shopper picks a tab. The builder boots
       before this script runs, so read its html[data-trkb-method] flag first, then listen for changes. */
    var follow = function (m) {
      if (picked) return;
      if (m === 'gun' || m === 'aerosol') select(m === 'gun' ? 'gun' : 'aero');
    };
    select('aero');
    follow(document.documentElement.getAttribute('data-trkb-method'));
    document.addEventListener('trkb:method', function (e) { follow(e.detail && e.detail.method); });
  }

  /* FAQ: one open at a time (native via name=, this covers older browsers). */
  var faqs = [].slice.call(root.querySelectorAll('.trcg-faq details'));
  faqs.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      faqs.forEach(function (o) { if (o !== d && o.open) o.open = false; });
    });
  });

  /* Jump bar scroll-spy. */
  var chips = [].slice.call(root.querySelectorAll('.trcg-chip'));
  if (chips.length && 'IntersectionObserver' in window) {
    var mark = function (id) {
      chips.forEach(function (c) {
        if (c.getAttribute('href') === '#' + id) c.setAttribute('aria-current', 'true');
        else c.removeAttribute('aria-current');
      });
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) mark(en.target.id); });
    }, { rootMargin: '-35% 0px -60% 0px' });
    [].slice.call(root.querySelectorAll('[data-trcg-spy]')).forEach(function (s) { io.observe(s); });
  }

  /* Printed copy: shown only when the kit builder is running and offers it. */
  var wrap = root.querySelector('[data-trcg-printed]');
  var btn = root.querySelector('[data-trcg-printed-btn]');
  var builder = function () { return document.querySelector('[data-trkb-root][data-printed-guide="true"]'); };
  var check = function () {
    if (wrap && wrap.hidden && document.querySelector('.trpd.trkb-on') && builder()) wrap.hidden = false;
  };
  if (btn) {
    btn.addEventListener('click', function () {
      document.dispatchEvent(new CustomEvent('trkb:guide', { detail: { on: true } }));
      var b = builder();
      if (b) {
        var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        b.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
  window.addEventListener('load', check);

  /* Long cards (the multi-stage notes): clipped with a fade and a "Read more" button. The text
     stays in the page; without this script every card shows in full. */
  var clampN = 0;
  [].slice.call(root.querySelectorAll('[data-trcg-clamp]')).forEach(function (el) {
    var inner = document.createElement('span');
    inner.className = 'trcg-clamp-in';
    inner.id = 'trcg-clamp-' + (++clampN);
    while (el.firstChild) inner.appendChild(el.firstChild);
    el.appendChild(inner);
    var cut = parseInt(getComputedStyle(el).getPropertyValue('--trcg-clamp'), 10) || 168;
    if (inner.scrollHeight <= cut + 56) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'trcg-clamp-btn';
    b.setAttribute('aria-controls', inner.id);
    var set = function (open) {
      el.classList.toggle('is-shut', !open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.textContent = open ? 'Show less' : 'Read more';
    };
    el.classList.add('trcg-clamped');
    set(false);
    b.addEventListener('click', function () { set(el.classList.contains('is-shut')); });
    /* a link to this card (the Color steps point at the multi-stage note) opens it */
    el.addEventListener('focusin', function () { if (el.classList.contains('is-shut')) set(true); });
    el.appendChild(b);
    el._trcgOpen = function () { set(true); };
  });
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#trcg-layer"]');
    if (!a) return;
    var el = document.getElementById('trcg-layer');
    if (el && el._trcgOpen) el._trcgOpen();
  });

  /* The "In short" and How to blend steps are <details> (2026-10-09; they were a pinned scroll panel): nothing to run.
     The jump bar sticks under the store's own sticky header, if it has one. */
  var headerBottom = function () {
    var bottom = 0;
    [].forEach.call(document.querySelectorAll('header, .section-header, sticky-header, .shopify-section-header-sticky'), function (h) {
      var cs = window.getComputedStyle(h);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var r = h.getBoundingClientRect();
      if (r.top <= 1 && r.bottom > bottom && r.bottom < window.innerHeight / 3) bottom = r.bottom;
    });
    return Math.round(bottom);
  };
  var setStickyTop = function () { root.style.setProperty('--trcg-sticky-top', headerBottom() + 'px'); };
  setStickyTop();
  window.addEventListener('resize', setStickyTop);

  /* Phones (2026-10-22 pre-launch pass): each guide block folds to its eyebrow + heading, and the heading becomes the
     button that opens it (accordion), so the page is about half as long. Nothing is removed: the text stays in the
     page, every block shows in full without this script and on wider screens. A jump chip, an in-page link
     (#trcg-guides, #trcg-faq, #trcg-qty, #trcg-layer ...) or keyboard focus inside a block opens it first. */
  var phone = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var folds = [];
  [].slice.call(root.querySelectorAll('.trcg-block[id]')).forEach(function (blk) {
    var h = null;
    for (var c = blk.firstElementChild; c; c = c.nextElementSibling) { if (c.classList.contains('trcg-h2')) { h = c; break; } }
    if (!h) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'trcg-fold';
    b.setAttribute('aria-controls', blk.id);
    while (h.firstChild) b.appendChild(h.firstChild);
    h.appendChild(b);
    var set = function (open) {
      var was = blk.classList.contains('is-folded');
      blk.classList.toggle('is-folded', !open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      /* a carousel inside (Sizes at a glance) measured itself while folded: let it measure again now */
      if (open && was) { try { window.dispatchEvent(new Event('resize')); } catch (x) {} }
    };
    b.addEventListener('click', function () { set(blk.classList.contains('is-folded')); });
    blk.addEventListener('focusin', function (e) { if (e.target !== b && blk.classList.contains('is-folded')) set(true); });
    folds.push({ blk: blk, set: set, b: b });
  });
  var applyFolds = function () {
    var on = !!(phone && phone.matches);
    root.classList.toggle('trcg-folds', on);
    folds.forEach(function (f) { f.set(!on); });
  };
  var openFor = function (id) {
    var el = id && document.getElementById(id);
    if (!el) return;
    folds.forEach(function (f) { if (f.blk === el || f.blk.contains(el)) f.set(true); });
  };
  if (folds.length) {
    applyFolds();
    if (phone && phone.addEventListener) phone.addEventListener('change', applyFolds);
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (a) openFor(a.getAttribute('href').slice(1));
    }, true);
    if (location.hash) openFor(location.hash.slice(1));
    window.addEventListener('hashchange', function () { openFor(location.hash.slice(1)); });
  }
})();
